document.addEventListener("DOMContentLoaded", function() {
  // — grab the product’s price from hidden input —
  const productPriceInput = document.getElementById("product-price");
  let productPrice = productPriceInput ? parseFloat(productPriceInput.value) || 0 : 0;
  console.log("✅ productPrice from input:", productPrice);

  // — tab toggle buttons & forms —
  const printingBtn = document.getElementById("method-printing");
  const embroideryBtn = document.getElementById("method-embroidery");
  const printingForm = document.getElementById("printing-form");
  const embroideryForm = document.getElementById("embroidery-form");
  const sharedForm = document.getElementById("quote-form");

  if (!printingBtn || !embroideryBtn || !printingForm || !embroideryForm || !sharedForm) {
    console.error("❌ Missing required elements for tab toggle");
    return;
  }

  function showPrinting() {
    console.log("Switching to Printing form");
    printingBtn.classList.add("active");
    embroideryBtn.classList.remove("active");
    printingForm.style.display = "";
    embroideryForm.style.display = "none";
    sharedForm.style.display = "none";
  }

  function showEmbroidery() {
    console.log("Switching to Embroidery form");
    embroideryBtn.classList.add("active");
    printingBtn.classList.remove("active");
    embroideryForm.style.display = "";
    printingForm.style.display = "none";
    sharedForm.style.display = "none";
  }

  printingBtn.addEventListener("click", showPrinting);
  embroideryBtn.addEventListener("click", showEmbroidery);

  // — PRINTING logic (unchanged, working fine) —
  const qtySelect = document.getElementById("quote-qty");
  const printResult = document.getElementById("quote-result");
  const printCTA = document.getElementById("quote-cta");
  const showPrintForm = document.getElementById("show-contact-form");
  const quoteDetailsInput = document.getElementById("quote-details");
  const quoteUrlInput = document.getElementById("quote-page-url");

  if (!qtySelect || !printResult || !printCTA || !showPrintForm || !quoteDetailsInput || !quoteUrlInput) {
    console.error("❌ Missing required elements for printing form");
    return;
  }

  const pricingTable = {
    24: [7.50, 8.50, 10.00, 14.00],
    36: [6.50, 7.50, 9.00, 10.00],
    48: [5.75, 6.40, 7.00, 9.00],
    72: [4.85, 5.00, 5.75, 6.25],
    100: [4.50, 4.75, 5.00, 5.35],
    150: [4.35, 4.50, 4.70, 5.25],
    250: [3.00, 3.00, 3.25, 4.00],
    500: [2.45, 2.50, 2.70, 3.50],
    1000: [1.90, 2.00, 2.00, 2.70],
    2000: [1.50, 1.60, 1.60, 2.10]
  };

  function getBaseQty(q) {
    const ks = Object.keys(pricingTable).map(Number).sort((a, b) => a - b);
    for (let i = ks.length - 1; i >= 0; i--) {
      if (q >= ks[i]) return ks[i];
    }
    return ks[0];
  }

  function updatePrinting() {
    const v = parseInt(qtySelect.value);
    if (!v) {
      printResult.textContent = "$0.00";
      printCTA.style.display = "none";
      quoteDetailsInput.value = "";
      return;
    }

    const base = getBaseQty(v);
    let totalPrint = 0;
    let quoteDetails = `Quantity: ${v}\nPrint Colors:\n`;
    for (let i = 1; i <= 4; i++) {
      const sel = document.querySelector(`.color-button.selected[data-group="loc${i}"]`);
      const c = sel ? parseInt(sel.dataset.value) : 0;
      if (c > 0) totalPrint += pricingTable[base][Math.min(c, 4) - 1] || 0;
      quoteDetails += `  Location ${i}: ${c}\n`;
    }
    if (totalPrint === 0) {
      printResult.textContent = "$0.00";
      printCTA.style.display = "none";
      quoteDetailsInput.value = "";
      return;
    }
    const unit = productPrice + totalPrint;
    printResult.textContent = `$${unit.toFixed(2)}`;
    printCTA.style.display = "";
    quoteDetailsInput.value = quoteDetails.trim();

    // Set the product URL with variant
    const currentUrl = window.location.href;
    quoteUrlInput.value = currentUrl;
  }

  qtySelect.addEventListener("change", () => {
    console.log("Quantity changed:", qtySelect.value);
    updatePrinting();
  });

  document.querySelectorAll(".color-button").forEach(btn => {
    btn.addEventListener("click", () => {
      const grp = btn.dataset.group;
      console.log(`Color button clicked: group=${grp}, value=${btn.dataset.value}`);
      document.querySelectorAll(`.color-button[data-group="${grp}"]`)
        .forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");
      updatePrinting();
    });
  });

  showPrintForm.addEventListener("click", () => {
    console.log("Show Print Form clicked");
    sharedForm.style.display = "";
    printCTA.style.display = "none";
  });

  // — EMBROIDERY logic —
  const embQty = document.getElementById("emb-qty");
  const embResult = document.getElementById("emb-quote-result");
  const embCTA = document.getElementById("emb-quote-cta");
  const showEmbForm = document.getElementById("emb-show-contact-form");
  const embResultValue = document.getElementById("emb-quote-result-value");

  if (!embQty || !embResult || !embCTA || !showEmbForm || !quoteDetailsInput || !quoteUrlInput || !embResultValue) {
    console.error("❌ Missing required elements for embroidery form");
    return;
  }

  function stitchCost(qty, stitches) {
    const basePrices = {24: 7.00, 50: 6.50, 100: 6.50, 150: 6.25, 200: 5.00, 250: 5.00, 500: 4.50, 1000: 4.00, 2500: 3.50};
    const brackets = Object.keys(basePrices).map(Number).sort((a, b) => a - b);
    let bracket = brackets.find(b => qty <= b) || brackets[brackets.length - 1];
    let baseCost = basePrices[bracket] || 0;
    let additionalStitches = Math.max(0, stitches - 7000);
    let additionalCost = Math.floor(additionalStitches / 1000) * 0.45;
    return baseCost + additionalCost;
  }

  function updateEmbroidery() {
    const q = parseInt(embQty.value);
    if (!q) {
      embResultValue.textContent = "$0.00";
      embCTA.style.display = "none";
      quoteDetailsInput.value = "";
      return;
    }
    let total = 0;
    let quoteDetails = `Quantity: ${q}\nStitches:\n`;
    for (let i = 1; i <= 3; i++) {
      const s = parseInt(document.getElementById(`emb-stitches-${i}`).value) || 0;
      if (s > 0) total += stitchCost(q, s);
      quoteDetails += `  Location ${i}: ${s || 0}\n`;
    }
    if (total === 0) {
      embResultValue.textContent = "$0.00";
      embCTA.style.display = "none";
      quoteDetailsInput.value = "";
      return;
    }
    const unit = productPrice + total;
    embResultValue.textContent = `$${unit.toFixed(2)}`;
    embCTA.style.display = "";
    quoteDetailsInput.value = quoteDetails.trim();

    // Set the product URL with variant
    const currentUrl = window.location.href;
    quoteUrlInput.value = currentUrl;
  }

  embQty.addEventListener("change", () => {
    console.log("Embroidery quantity changed:", embQty.value);
    updateEmbroidery();
  });

  for (let i = 1; i <= 3; i++) {
    const stitchSelect = document.getElementById(`emb-stitches-${i}`);
    if (stitchSelect) {
      stitchSelect.addEventListener("change", () => {
        console.log(`Stitch select ${i} changed:`, stitchSelect.value);
        updateEmbroidery();
      });
    }
  }

  showEmbForm.addEventListener("click", () => {
    console.log("Show Embroidery Form clicked");
    sharedForm.style.display = "";
    embCTA.style.display = "none";
  });

  // — Initial state and updates —
  showPrinting(); // Start in printing mode
  updatePrinting(); // Initialize printing quote
  updateEmbroidery(); // Initialize embroidery quote

  // — Handle URL parameter for confirmation —
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("contact_posted") === "true") {
    sharedForm.style.display = "none";
    printCTA.style.display = "none";
    embCTA.style.display = "none";
  }

  // — Uploadcare logic —
  try {
    const ucWidget = uploadcare.Widget("#uploadcare-file-input");
    const fileUrlInput = document.getElementById("quote-file-url");
    if (ucWidget && fileUrlInput) {
      ucWidget.onUploadComplete(function(fileInfo) {
        fileUrlInput.value = fileInfo.cdnUrl;
        console.log("✅ Uploaded file URL:", fileInfo.cdnUrl);
      });
    }
  } catch (e) {
    console.error("❌ Uploadcare error:", e);
  }
});